export const SUPPORT_DEPT_DATA = {
  health: {
    score: 82,
    trend: '+4',
    status: 'green',
    summary: 'Resolution times improved 18% this week. CSAT is at 4.6/5. One P1 escalation active (Acme Corp API outage). Churn risk flagged for 2 accounts.',
  },

  agents: [
    {
      id: 'zira',
      name: 'Zira',
      role: 'Support Intelligence AI',
      status: 'active',
      currentTask: 'Coordinating P1 response for Acme Corp — hotfix ETA 2 hours',
      lastAction: 'Auto-escalated Acme Corp ticket to engineering after SLA breach',
      lastActionTime: '12 min ago',
    },
  ],

  alerts: [
    {
      id: 'spa1',
      title: 'Acme Corp API outage — P1 escalation active',
      severity: 'high',
      agents: ['zira'],
      description: 'Acme Corp ($120K ARR) experiencing intermittent API failures since 6 AM. Engineering deployed hotfix, ETA 2 hours. CTO has been notified proactively.',
      actions: [
        { agent: 'zira', label: 'Sent proactive status update to Acme Corp CTO', status: 'complete' },
        { agent: 'zira', label: 'Escalated hotfix priority to engineering — ETA 2 hrs', status: 'in-progress' },
        { agent: 'zira', label: 'Prepared rollback plan if hotfix fails', status: 'complete' },
      ],
    },
    {
      id: 'spa2',
      title: 'Churn risk: Meridian Group — usage dropped 60% in 2 weeks',
      severity: 'high',
      agents: ['zira'],
      description: 'Meridian Group ($28K ARR) usage has dropped sharply. Key contact (Lisa Park) hasn\'t logged in for 9 days. Last interaction was a frustration ticket about onboarding.',
      actions: [
        { agent: 'zira', label: 'Analyzed usage patterns — drop coincides with key feature removal in v3.2', status: 'complete' },
        { agent: 'zira', label: 'Draft personalized re-engagement email with workaround', status: 'in-progress' },
        { agent: 'zira', label: 'Flag to Customer Success for executive outreach', status: 'recommended' },
      ],
    },
    {
      id: 'spa3',
      title: 'Ticket volume spike: 42% increase from integration errors',
      severity: 'medium',
      agents: ['zira'],
      description: 'Webhook integration tickets surged after the v3.2 release. Most are configuration-related, not bugs. Pattern suggests documentation gap.',
      actions: [
        { agent: 'zira', label: 'Created auto-response with webhook config guide for common errors', status: 'complete' },
        { agent: 'zira', label: 'Drafted knowledge base article for webhook migration', status: 'in-progress' },
      ],
    },
  ],

  decisions: [
    { id: 'spd1', title: 'Extend Acme Corp SLA credit ($2,400) for P1 outage', agent: 'zira', urgency: 'high', detail: 'Acme Corp is requesting SLA credit for 4 hours of downtime. Our SLA guarantees 99.9% uptime. Credit amount: $2,400. Zira recommends approving to maintain relationship — they\'re up for renewal in 6 weeks.' },
    { id: 'spd2', title: 'Approve dedicated support engineer for Enterprise tier', agent: 'zira', urgency: 'medium', detail: '3 Enterprise accounts have requested dedicated support. Adding 1 FTE ($85K/yr) would cover the top 5 accounts ($420K combined ARR). ROI: 4.9x.' },
  ],

  tickets: [
    { id: 'st1', title: 'Acme Corp — API intermittent failures', priority: 'P1', status: 'in-progress', account: 'Acme Corp', arr: '$120K', sla: 'Breached', owner: 'Maya Singh' },
    { id: 'st2', title: 'Meridian Group — Onboarding friction', priority: 'P2', status: 'open', account: 'Meridian Group', arr: '$28K', sla: 'At risk', owner: 'Maya Singh' },
    { id: 'st3', title: 'CloudNine — Webhook config errors', priority: 'P3', status: 'open', account: 'CloudNine', arr: '$18K', sla: 'OK', owner: 'Alex Rivera' },
    { id: 'st4', title: 'NovaTech — SSO setup assistance', priority: 'P3', status: 'in-progress', account: 'NovaTech', arr: '$28K', sla: 'OK', owner: 'Alex Rivera' },
    { id: 'st5', title: 'DataFlow — Data export timeout', priority: 'P2', status: 'open', account: 'DataFlow', arr: '$32K', sla: 'OK', owner: 'Maya Singh' },
  ],

  metrics: [
    { label: 'Open Tickets', value: '23', trend: '+42%', trendUp: false, alert: true },
    { label: 'Avg. Resolution', value: '4.2 hrs', trend: '-18%', trendUp: true },
    { label: 'CSAT Score', value: '4.6/5', trend: '+0.3', trendUp: true },
    { label: 'First Response', value: '8 min', trend: '-22%', trendUp: true },
    { label: 'Churn Risk', value: '2 accts', trend: '+1', trendUp: false, alert: true },
    { label: 'NPS', value: '72', trend: '+5', trendUp: true },
  ],

  recentActivity: [
    { id: 'sra1', agent: 'zira', action: 'auto-escalated Acme Corp P1 to engineering after SLA breach', time: '12 min ago', type: 'alert' },
    { id: 'sra2', agent: 'zira', action: 'sent proactive status update to Acme Corp CTO', time: '25 min ago', type: 'action' },
    { id: 'sra3', agent: 'zira', action: 'flagged Meridian Group as churn risk — usage dropped 60%', time: '1 hr ago', type: 'alert' },
    { id: 'sra4', agent: 'zira', action: 'created auto-response template for webhook configuration errors', time: '2 hrs ago', type: 'action' },
    { id: 'sra5', agent: 'zira', action: 'analyzed ticket volume spike — root cause: v3.2 webhook changes', time: '3 hrs ago', type: 'insight' },
    { id: 'sra6', agent: 'zira', action: 'resolved 4 P3 tickets via automated knowledge base suggestions', time: '4 hrs ago', type: 'action' },
    { id: 'sra7', agent: 'zira', action: 'prepared SLA credit recommendation for Acme Corp ($2,400)', time: '5 hrs ago', type: 'action' },
    { id: 'sra8', agent: 'zira', action: 'identified documentation gap for webhook migration guide', time: 'Yesterday', type: 'insight' },
  ],
};

export const SUPPORT_DEPT_CHAT_RESPONSES = {
  deepDive: {
    text: "Here's my strategic analysis of Support.\n\nOverall health is strong at 82 — CSAT improved to 4.6 and resolution times are down 18%. However, two issues need CEO attention:",
    actions: [
      { agent: 'zira', label: 'Acme Corp P1 outage — SLA breached, hotfix deploying in 2 hrs. Recommend approving $2,400 SLA credit ahead of renewal', status: 'pending-approval' },
      { agent: 'zira', label: 'Meridian Group churn risk — usage dropped 60%. Root cause: feature removal in v3.2. Re-engagement plan drafted', status: 'in-progress' },
      { agent: 'zira', label: 'Ticket volume spiked 42% from webhook integration issues. Auto-responses deployed, KB article in progress', status: 'in-progress' },
      { agent: 'zira', label: 'Enterprise accounts requesting dedicated support engineer — ROI case prepared ($85K cost vs $420K ARR coverage)', status: 'recommended' },
    ],
    timeline: 'If the Acme Corp credit is approved today and the hotfix lands on time, Zira projects the P1 will be fully resolved by EOD.',
  },
  general: {
    text: "I'm monitoring Support closely. Here's the current state:\n\nThe Acme Corp P1 is our top priority — engineering is deploying a hotfix within 2 hours. I've already sent a proactive update to their CTO.\n\nThe 42% ticket spike is under control — most are webhook config issues from v3.2, and I've deployed auto-responses to handle the common cases.\n\nTwo items need your attention: the SLA credit approval for Acme, and a churn risk flag on Meridian Group.\n\nWant me to dig into any of these?",
  },
};
